import { useCallback, useEffect, useState } from 'react';
import axios from 'axios';
import { toast } from 'react-toastify';
import ScheduledGoalList from '../goals/scheduled-goal-list';

export default function QUARTER({ quarter, yearId, refreshVersion, refreshGoals }) {
  const [expanded, setExpanded] = useState(false);
  const [goals, setGoals] = useState([]);
  const [endDate, setEndDate] = useState(quarter.endDate.slice(0, 10));
  const [savedEndDate, setSavedEndDate] = useState(quarter.endDate);
  const [error, setError] = useState('');
  const fetchGoals = useCallback(async () => {
    try {
      const { data } = await axios.post(`${process.env.REACT_APP_WEB_URL}api/goals/get-goals-for-quarter`, { yearId, quarterNumber: quarter.quarterNumber }, { withCredentials: true });
      if (!Array.isArray(data)) throw new Error();
      setGoals(data);
      setError('');
    } catch { setError('Unable to load the goals for this quarter.'); }
  }, [yearId, quarter.quarterNumber]);
  useEffect(() => { fetchGoals(); }, [fetchGoals, refreshVersion]);
  useEffect(() => { setSavedEndDate(quarter.endDate); setEndDate(quarter.endDate.slice(0, 10)); }, [quarter.endDate]);

  const saveEndDate = async event => {
    event.preventDefault();
    try {
      const { data } = await axios.put(`${process.env.REACT_APP_WEB_URL}api/quarters/${quarter._id}`, { endDate }, { withCredentials: true });
      setSavedEndDate(data.quarter.endDate);
      toast.success('Quarter end date updated.');
    } catch { toast.error('Unable to update the quarter end date.'); }
  };

  return <section className="quarter-overview">
    <button type="button" className="accordion accordion--title" aria-expanded={expanded} aria-controls={`quarter-${quarter._id}`} onClick={() => setExpanded(value => !value)}>
      <h3>Quarter {quarter.quarterNumber} — {new Date(savedEndDate).toLocaleDateString('en-GB')} — {goals.reduce((total, goal) => total + (goal.points || 0), 0)} points</h3>
    </button>
    {expanded && <div id={`quarter-${quarter._id}`} className="quarter-overview__body">
      <form onSubmit={saveEndDate}>
        <label htmlFor={`quarter-end-${quarter._id}`}>Quarter end date</label>
        <input id={`quarter-end-${quarter._id}`} type="date" required value={endDate} onChange={event => setEndDate(event.target.value)} />
        <button type="submit">Update end date</button>
      </form>
      {error && <p role="alert">{error} <button onClick={fetchGoals}>Try again</button></p>}
      {goals.length ? <ScheduledGoalList goals={goals} refreshGoals={refreshGoals || fetchGoals} /> : <p>No goals for this quarter yet.</p>}
    </div>}
  </section>;
}
